import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditEmploymentPage = {
  alert: {
    error: 'coapplicant-edit-employment-page.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-employment-page.footer.root',
  },
  form: {
    cancelButton: 'coapplicant-edit-employment-page.form.cancel-button',
    employerNameInput:
      'coapplicant-edit-employment-page.form.employer-name-input',
    employerNameInputError:
      'coapplicant-edit-employment-page.form.employer-name-input-error',
    employmentDurationSelect:
      'coapplicant-edit-employment-page.form.employment-duration-select',
    employmentDurationSelectError:
      'coapplicant-edit-employment-page.form.employment-duration-select-error',
    employmentStatusSelect:
      'coapplicant-edit-employment-page.form.employment-status-select',
    employmentStatusSelectError:
      'coapplicant-edit-employment-page.form.employment-status-select-error',
    employmentTypeSelect:
      'coapplicant-edit-employment-page.form.employment-type-select',
    employmentTypeSelectError:
      'coapplicant-edit-employment-page.form.employment-type-select-error',
    grossAnnualIncomeInput:
      'coapplicant-edit-employment-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'coapplicant-edit-employment-page.form.gross-annual-income-input-error',
    h1: 'coapplicant-edit-employment-page.form.h1',
    h2: 'coapplicant-edit-employment-page.form.h2',
    jobTitleInput: 'coapplicant-edit-employment-page.form.job-title-input',
    jobTitleInputError:
      'coapplicant-edit-employment-page.form.job-title-input-error',
    previousEmployerNameInput:
      'coapplicant-edit-employment-page.form.previous-employer-name-input',
    previousEmployerNameInputError:
      'coapplicant-edit-employment-page.form.previous-employer-name-input-error',
    previousEmploymentGrossAnnualIncomeInput:
      'coapplicant-edit-employment-page.form.previous-employment-gross-annual-income-input',
    previousEmploymentGrossAnnualIncomeInputError:
      'coapplicant-edit-employment-page.form.previous-employment-gross-annual-income-input-error',
    previousEmploymentH3:
      'coapplicant-edit-employment-page.form.previous-employment-h3',
    previousEmploymentJobTitleInput:
      'coapplicant-edit-employment-page.form.previous-employment-job-title-input',
    previousEmploymentJobTitleInputError:
      'coapplicant-edit-employment-page.form.previous-employment-job-title-input-error',
    previousEmploymentRoot:
      'coapplicant-edit-employment-page.form.previous-employment-root',
    previousEmploymentTypeSelect:
      'coapplicant-edit-employment-page.form.previous-employment-type-select',
    previousEmploymentTypeSelectError:
      'coapplicant-edit-employment-page.form.previous-employment-type-select-error',
    root: 'coapplicant-edit-employment-page.form.root',
    submitButton: 'coapplicant-edit-employment-page.form.submit-button',
    unemploymentGrossAnnualIncomeInput:
      'coapplicant-edit-employment-page.form.unemployment-gross-annual-income-input',
    unemploymentGrossAnnualIncomeInputError:
      'coapplicant-edit-employment-page.form.unemployment-gross-annual-income-input-error',
    unemploymentTypeSelect:
      'coapplicant-edit-employment-page.form.unemployment-type-select',
    unemploymentTypeSelectError:
      'coapplicant-edit-employment-page.form.unemployment-type-select-error',
  },
  header: {
    drawerButton: 'coapplicant-edit-employment-page.header.drawer-button',
    previousStepButton:
      'coapplicant-edit-employment-page.header.previous-step-button',
    root: 'coapplicant-edit-employment-page.header.root',
  },
  progress: {
    root: 'coapplicant-edit-employment-page.progress.root',
  },
} as const satisfies PageLocatorMap;
